import React from 'react'
import { formatDateTime } from '../common/utilities'
import { RadCards } from '../common/RadCards'
import { RadBox } from '../common/RadBox'
import { RadBadge } from '../common/RadBadge'
import { RadButton } from '../common/RadButton'
import { RadSpaceBetween } from '../common/RadSpaceBetween'
import './CollectionCards.scss'

export function CollectionCards ({
  collections,
  showModal = false,
  cardsPerRow,
  empty,
  variant = 'full-page',
  minimal = false
}) {
  const sections = [
    {
      id: 'count',
      content: item => (
        <RadBox color='text-body-secondary' fontSize='body-s' fontWeight='normal'>
          <i>{`${item.resourceCount} resources`}</i>
        </RadBox>
      )
    },
    {
      id: 'description',
      content: item => (
        <RadBox>
          {item.description}
        </RadBox>
      )
    },
    {
      id: 'links',
      content: item => (
        item.featuredBlogPostName && item.featuredBlogPostUrl && (
          <RadButton
            href={item.featuredBlogPostUrl}
            target='_blank'
            external
            fullWidth
          >
            About Collection
          </RadButton>
        )
      )
    },
    {
      id: 'updatedAt',
      content: item =>
        <RadBox color='text-body-secondary' fontSize='body-s' fontWeight='normal'>
          {`Updated: ${formatDateTime(item.updatedAt)}`}
        </RadBox>
    }
  ].filter(s => !minimal || ['description'].includes(s.id))

  const headerClass = item => `collection-cards-header ${!minimal && item.isFeatured ? 'featured-card-header' : ''}`
    .trim()

  return (
    <RadCards
      className='collection-cards'
      cardDefinition={{
        header: item => (
          <RadSpaceBetween
            direction='horizontal'
            size='s'
            alignItems='flex-start'
            className={headerClass(item)}
          >
            <RadButton
              href={`/resource?collectionId=${item.id}`}
              variant='inline-link'
            >
              {item.name}
            </RadButton>
            {!minimal && item.isFeatured && <RadBadge featured>Featured</RadBadge>}
          </RadSpaceBetween>
        ),
        sections
      }}
      cardsPerRow={cardsPerRow || [
        { cards: 1 },
        { minWidth: 640, cards: 2 },
        { minWidth: 960, cards: 3 },
        { minWidth: 1280, cards: 4 }
      ]}
      items={collections}
      empty={empty || (
        <RadBox textAlign='center' color='inherit'>
          No collections found.
        </RadBox>
      )}
      variant={variant}
    />
  )
}
